exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-amenities svg{display:inline-block;vertical-align:middle;height:15px;fill:gray;margin:0 -1px}.property-amenities svg path{fill:gray}.ie .property-amenities svg{max-width:20px}", ""]);

// exports
